import { render, staticRenderFns } from "./AddGnbReportTemplate.vue?vue&type=template&id=5fd5ab9c&scoped=true&"
import script from "./AddGnbReportTemplate.vue?vue&type=script&lang=js&"
export * from "./AddGnbReportTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5ab9c",
  null
  
)

export default component.exports